<form [formGroup]="form" (ngSubmit)="onSalvar()" (keydown.enter)="$event.preventDefault()" class="tutorial-item-list">
  <header class="col-lg-12 header-items" *ngIf="isAdmin">
    <div class="nav-buttons">
      <button class="btn btn-white btn-select" type="button" *ngIf="!selected"> 
        <input type="checkbox" class="me-2"  (click)="selectAll($event)"> Selecionar vários
      </button>
      <div class="div-actions" type="button" *ngIf="selected"> 
        <input type="checkbox" (click)="selectAll($event)" [checked]="allSelected()">
        <button class="btn btn-blue btn-icon" type="button" title="Deletar item" (click)="deleteItems()">
          <span class="font-icon">delete</span> Excluir selecionados
        </button>
        <button class="btn btn-blue btn-icon" type="button" title="Restaurar item" (click)="changeItems(false)">
          <span class="font-icon">visibility_off</span> Ocultar selecionados
        </button>
        <button class="btn btn-blue btn-icon" type="button" title="Ocultar item" (click)="changeItems(true)">
          <span class="font-icon">visibility</span> Restaurar ocultados
        </button>
      </div>
      <div class="d-flex">
        <button class="btn btn-white" type="button" *ngIf="!isOrdering" (click)="isOrdering = true"> 
          <span class="font-icon me-1">swap_vert</span>Ordenar
        </button>
        <button class="btn btn-blue" type="button" *ngIf="isOrdering" (click)="onChangeOrder()"> 
          <span class="font-icon me-1">swap_vert</span>Salvar Ordem 
        </button>
        <button class="btn btn-blue-2" type="button" (click)="onOpenModal()"> 
          <span class="font-icon me-1">add_box</span>Novo tutorial
        </button>
      </div>
    </div>
    
  </header>
  
  <section class="section-card col-12" cdkDropList [cdkDropListDisabled]="!isAdmin || !isOrdering" (cdkDropListDropped)="drop($event)" formArrayName="data">
    <ng-container *ngFor="let item of sortData(true)"  >
      <app-tutorial-item [isOrdering]="isOrdering"  [isAdmin]="isAdmin" [index]="getIndexForm(item)" [type]="type"
        [item]="item" [parentFormGroup]="form?.get('data')" 
        (openModal)="onOpenModal($event)"  (delete)="confirmExcluir(item.id)" (changeShow)="onChangeShow(item.id, $event)" 
        (selectItem)="selectItem()" (openItem)="onOpenItem($event)">
      </app-tutorial-item>
    </ng-container>
  </section>
  <h3 *ngIf="isAdmin && anyDisable()">Ocultados</h3>
  <section *ngIf="isAdmin && anyDisable()" class="section-card col-12" cdkDropList [cdkDropListDisabled]="!isAdmin || !isOrdering" (cdkDropListDropped)="drop($event)" formArrayName="data">
    <ng-container *ngFor="let item of sortData(false)"  >
      <app-tutorial-item [isOrdering]="isOrdering"  [isAdmin]="isAdmin" [index]="getIndexForm(item)" [type]="type"
        [item]="item"  [parentFormGroup]="form?.get('data')" disabled="true"
        (openModal)="onOpenModal($event)"  (delete)="confirmExcluir(item.id)" (changeShow)="onChangeShow(item.id, $event)"
        (selectItem)="selectItem()" (openItem)="onOpenItem($event)">
      </app-tutorial-item>
    </ng-container>
  </section>
</form>